import React, { useEffect, useState } from 'react';
import {
  getAlertes, getAlertesStats, createAlerte, resoudreAlerte,
  marquerAlerteVue, autoCheckAlertes, getStations
} from '../services/api';

const TYPE_LABELS: Record<string, string> = {
  stock_bas: 'Stock bas',
  ecart_vente: 'Ecart de vente',
  retard_saisie: 'Retard saisie',
  depense_excessive: 'Depense excessive',
  maintenance: 'Maintenance',
  securite: 'Securite',
  autre: 'Autre',
};

const Alertes: React.FC = () => {
  const [alertes, setAlertes] = useState<any[]>([]);
  const [stats, setStats] = useState<any>(null);
  const [stations, setStations] = useState<any[]>([]);
  const [filterStatut, setFilterStatut] = useState('');
  const [filterType, setFilterType] = useState('');
  const [filterSeverite, setFilterSeverite] = useState('');
  const [filterStation, setFilterStation] = useState('');
  const [loading, setLoading] = useState(true);
  const [checking, setChecking] = useState(false);
  const [showCreate, setShowCreate] = useState(false);
  const [showDetail, setShowDetail] = useState<any>(null);
  const [showResolve, setShowResolve] = useState<any>(null);
  const [noteResolution, setNoteResolution] = useState('');
  const [createForm, setCreateForm] = useState({ station_id: '', type_alerte: 'autre', severite: 'warning', titre: '', description: '' });

  useEffect(() => { getStations().then(r => setStations(r.data)).catch(() => {}); }, []);
  useEffect(() => { loadData(); }, [filterStatut, filterType, filterSeverite, filterStation]);

  const loadData = async () => {
    setLoading(true);
    try {
      const params: any = {};
      if (filterStatut) params.statut = filterStatut;
      if (filterType) params.type_alerte = filterType;
      if (filterSeverite) params.severite = filterSeverite;
      if (filterStation) params.station_id = filterStation;
      const [alertesRes, statsRes] = await Promise.all([getAlertes(params), getAlertesStats()]);
      setAlertes(alertesRes.data);
      setStats(statsRes.data);
    } catch (err) { console.error(err); }
    setLoading(false);
  };

  const handleCreate = async () => {
    if (!createForm.station_id || !createForm.titre) return;
    try {
      await createAlerte({ ...createForm, station_id: Number(createForm.station_id) });
      setShowCreate(false);
      setCreateForm({ station_id: '', type_alerte: 'autre', severite: 'warning', titre: '', description: '' });
      loadData();
    } catch (err) { console.error(err); }
  };

  const handleResolve = async () => {
    if (!showResolve) return;
    try {
      await resoudreAlerte(showResolve.id, { note_resolution: noteResolution || 'Resolu' });
      setShowResolve(null);
      setNoteResolution('');
      loadData();
    } catch (err) { console.error(err); }
  };

  const handleAutoCheck = async () => {
    setChecking(true);
    try {
      const res = await autoCheckAlertes();
      alert(`${res.data.message}\n${res.data.alertes.length > 0 ? res.data.alertes.join('\n') : 'Aucune nouvelle alerte'}`);
      loadData();
    } catch (err) { console.error(err); }
    setChecking(false);
  };

  const handleMarkVue = async (id: number) => {
    try { await marquerAlerteVue(id); loadData(); } catch (err) { console.error(err); }
  };

  return (
    <div>
      <div className="page-header">
        <h2>Alertes</h2>
        <div style={{ display: 'flex', gap: 8 }}>
          <button className="btn" onClick={() => setShowCreate(true)}>+ Nouvelle alerte</button>
          <button className="btn btn-secondary" onClick={handleAutoCheck} disabled={checking}>
            {checking ? 'Verification...' : 'Auto-detection'}
          </button>
        </div>
      </div>

      {stats && (
        <div className="stats-grid">
          <div className="stat-card"><div className="stat-value">{stats.total}</div><div className="stat-label">Total alertes</div></div>
          <div className="stat-card warning"><div className="stat-value">{stats.nouvelles}</div><div className="stat-label">Nouvelles</div></div>
          <div className="stat-card" style={{borderTop:'4px solid #e53935'}}><div className="stat-value">{stats.critiques}</div><div className="stat-label">Critiques non resolues</div></div>
          <div className="stat-card" style={{borderTop:'4px solid #78BE20'}}><div className="stat-value">{stats.resolues_aujourdhui}</div><div className="stat-label">Resolues aujourd'hui</div></div>
        </div>
      )}

      {/* Stats par type */}
      {stats && stats.parType && stats.parType.length > 0 && (
        <div className="card" style={{ marginBottom: 20 }}>
          <h3>Repartition par type</h3>
          <div style={{ display: 'flex', gap: 16, flexWrap: 'wrap' }}>
            {stats.parType.map((t: any) => (
              <div key={t.type_alerte} style={{ padding: '8px 16px', background: '#f8f9fa', borderRadius: 8, textAlign: 'center' }}>
                <div style={{ fontWeight: 600, fontSize: 18 }}>{t.total}</div>
                <div style={{ fontSize: 12, color: '#666' }}>{TYPE_LABELS[t.type_alerte] || t.type_alerte}</div>
                <div style={{ fontSize: 11, color: '#999' }}>{t.nouvelles} nouvelles / {t.resolues} resolues</div>
              </div>
            ))}
          </div>
        </div>
      )}

      {/* Filters */}
      <div className="filters" style={{ display: 'flex', gap: 8, flexWrap: 'wrap', marginBottom: 16 }}>
        <select value={filterStatut} onChange={e => setFilterStatut(e.target.value)} className="form-control" style={{ width: 140 }}>
          <option value="">Tous statuts</option>
          <option value="nouvelle">Nouvelles</option>
          <option value="vue">Vues</option>
          <option value="resolue">Resolues</option>
        </select>
        <select value={filterType} onChange={e => setFilterType(e.target.value)} className="form-control" style={{ width: 160 }}>
          <option value="">Tous types</option>
          {Object.entries(TYPE_LABELS).map(([k, v]) => <option key={k} value={k}>{v}</option>)}
        </select>
        <select value={filterSeverite} onChange={e => setFilterSeverite(e.target.value)} className="form-control" style={{ width: 130 }}>
          <option value="">Toutes severites</option>
          <option value="info">Info</option>
          <option value="warning">Warning</option>
          <option value="critical">Critical</option>
        </select>
        <select value={filterStation} onChange={e => setFilterStation(e.target.value)} className="form-control" style={{ width: 180 }}>
          <option value="">Toutes stations</option>
          {stations.map((s: any) => <option key={s.id} value={s.id}>{s.nom}</option>)}
        </select>
      </div>

      {loading ? <div className="loading">Chargement...</div> : (
        <>
          {alertes.length === 0 ? (
            <div className="card" style={{ textAlign: 'center', padding: 40, color: '#999' }}>Aucune alerte trouvee</div>
          ) : (
            <table className="table">
              <thead>
                <tr><th>Station</th><th>Type</th><th>Titre</th><th>Severite</th><th>Statut</th><th>Date</th><th>Actions</th></tr>
              </thead>
              <tbody>
                {alertes.map((a: any) => (
                  <tr key={a.id} style={{ background: a.statut === 'nouvelle' && a.severite === 'critical' ? '#fff5f5' : undefined }}>
                    <td>{a.station_nom}</td>
                    <td><span style={{ fontSize: 12 }}>{TYPE_LABELS[a.type_alerte] || a.type_alerte}</span></td>
                    <td>
                      <strong style={{ cursor: 'pointer', color: '#004A97' }} onClick={() => setShowDetail(a)}>{a.titre}</strong>
                      {a.description && <div style={{fontSize:12, color:'#666', maxWidth: 300, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap'}}>{a.description}</div>}
                    </td>
                    <td><span className={`badge badge-${a.severite}`}>{a.severite}</span></td>
                    <td><span className={`badge badge-${a.statut === 'resolue' ? 'success' : a.statut === 'nouvelle' ? 'warning' : 'info'}`}>{a.statut}</span></td>
                    <td>{new Date(a.created_at).toLocaleDateString('fr-FR')}</td>
                    <td>
                      <div style={{ display: 'flex', gap: 4 }}>
                        <button className="btn btn-sm" onClick={() => setShowDetail(a)}>Voir</button>
                        {a.statut === 'nouvelle' && (
                          <button className="btn btn-sm btn-secondary" onClick={() => handleMarkVue(a.id)}>Vu</button>
                        )}
                        {a.statut !== 'resolue' && (
                          <button className="btn btn-sm btn-success" onClick={() => { setShowResolve(a); setNoteResolution(''); }}>Resoudre</button>
                        )}
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          )}
        </>
      )}

      {/* Modal Creation */}
      {showCreate && (
        <div className="modal-overlay" onClick={() => setShowCreate(false)}>
          <div className="modal" onClick={e => e.stopPropagation()} style={{ maxWidth: 500 }}>
            <div className="modal-header">
              <h3>Nouvelle Alerte</h3>
              <button className="modal-close" onClick={() => setShowCreate(false)}>&times;</button>
            </div>
            <div className="modal-body">
              <div className="form-group">
                <label>Station *</label>
                <select className="form-control" value={createForm.station_id} onChange={e => setCreateForm({ ...createForm, station_id: e.target.value })}>
                  <option value="">Selectionner...</option>
                  {stations.map((s: any) => <option key={s.id} value={s.id}>{s.nom}</option>)}
                </select>
              </div>
              <div className="form-row">
                <div className="form-group">
                  <label>Type</label>
                  <select className="form-control" value={createForm.type_alerte} onChange={e => setCreateForm({ ...createForm, type_alerte: e.target.value })}>
                    {Object.entries(TYPE_LABELS).map(([k, v]) => <option key={k} value={k}>{v}</option>)}
                  </select>
                </div>
                <div className="form-group">
                  <label>Severite</label>
                  <select className="form-control" value={createForm.severite} onChange={e => setCreateForm({ ...createForm, severite: e.target.value })}>
                    <option value="info">Info</option>
                    <option value="warning">Warning</option>
                    <option value="critical">Critical</option>
                  </select>
                </div>
              </div>
              <div className="form-group">
                <label>Titre *</label>
                <input className="form-control" value={createForm.titre} onChange={e => setCreateForm({ ...createForm, titre: e.target.value })} />
              </div>
              <div className="form-group">
                <label>Description</label>
                <textarea className="form-control" rows={3} value={createForm.description} onChange={e => setCreateForm({ ...createForm, description: e.target.value })} />
              </div>
            </div>
            <div className="modal-footer">
              <button className="btn btn-secondary" onClick={() => setShowCreate(false)}>Annuler</button>
              <button className="btn" onClick={handleCreate} disabled={!createForm.station_id || !createForm.titre}>Creer</button>
            </div>
          </div>
        </div>
      )}

      {/* Modal Detail */}
      {showDetail && (
        <div className="modal-overlay" onClick={() => setShowDetail(null)}>
          <div className="modal" onClick={e => e.stopPropagation()} style={{ maxWidth: 500 }}>
            <div className="modal-header">
              <h3>Detail Alerte</h3>
              <button className="modal-close" onClick={() => setShowDetail(null)}>&times;</button>
            </div>
            <div className="modal-body">
              <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 12 }}>
                <div><strong>Station:</strong><br/>{showDetail.station_nom}</div>
                <div><strong>Type:</strong><br/>{TYPE_LABELS[showDetail.type_alerte] || showDetail.type_alerte}</div>
                <div><strong>Severite:</strong><br/><span className={`badge badge-${showDetail.severite}`}>{showDetail.severite}</span></div>
                <div><strong>Statut:</strong><br/><span className={`badge badge-${showDetail.statut === 'resolue' ? 'success' : showDetail.statut === 'nouvelle' ? 'warning' : 'info'}`}>{showDetail.statut}</span></div>
                <div style={{ gridColumn: '1 / -1' }}><strong>Titre:</strong><br/>{showDetail.titre}</div>
                {showDetail.description && <div style={{ gridColumn: '1 / -1' }}><strong>Description:</strong><br/>{showDetail.description}</div>}
                <div><strong>Creee le:</strong><br/>{new Date(showDetail.created_at).toLocaleString('fr-FR')}</div>
                {showDetail.date_resolution && (
                  <div><strong>Resolue le:</strong><br/>{new Date(showDetail.date_resolution).toLocaleString('fr-FR')}</div>
                )}
                {showDetail.resolu_par_nom && <div><strong>Resolue par:</strong><br/>{showDetail.resolu_par_nom}</div>}
                {showDetail.note_resolution && <div style={{ gridColumn: '1 / -1' }}><strong>Note resolution:</strong><br/>{showDetail.note_resolution}</div>}
              </div>
            </div>
            <div className="modal-footer">
              {showDetail.statut !== 'resolue' && (
                <button className="btn btn-success" onClick={() => { setShowResolve(showDetail); setShowDetail(null); setNoteResolution(''); }}>Resoudre</button>
              )}
              <button className="btn btn-secondary" onClick={() => setShowDetail(null)}>Fermer</button>
            </div>
          </div>
        </div>
      )}

      {/* Modal Resolution */}
      {showResolve && (
        <div className="modal-overlay" onClick={() => setShowResolve(null)}>
          <div className="modal" onClick={e => e.stopPropagation()} style={{ maxWidth: 450 }}>
            <div className="modal-header">
              <h3>Resoudre l'alerte</h3>
              <button className="modal-close" onClick={() => setShowResolve(null)}>&times;</button>
            </div>
            <div className="modal-body">
              <p><strong>{showResolve.titre}</strong></p>
              <p style={{ fontSize: 13, color: '#666' }}>{showResolve.station_nom} - {TYPE_LABELS[showResolve.type_alerte] || showResolve.type_alerte}</p>
              <div className="form-group">
                <label>Note de resolution</label>
                <textarea className="form-control" rows={3} value={noteResolution} onChange={e => setNoteResolution(e.target.value)}
                  placeholder="Decrivez comment l'alerte a ete resolue..." />
              </div>
            </div>
            <div className="modal-footer">
              <button className="btn btn-secondary" onClick={() => setShowResolve(null)}>Annuler</button>
              <button className="btn btn-success" onClick={handleResolve}>Confirmer resolution</button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default Alertes;
